import { useMutation } from "@tanstack/react-query";
import axiosInstance from "axiosConfig";
import { Toast } from "shared";
import { TOAST_TYPES_ENUM } from "enums";

interface ResendResponse {
  status: string;
  message?: string;
}

interface UseResendSuccessorSectionCodeOpts {
  onSuccess?: (data: ResendResponse) => void;
  onError?: (error: unknown) => void;
}

export function useResendSuccessorSectionCode(options?: UseResendSuccessorSectionCodeOpts) {
  return useMutation({
    mutationKey: ["resend-successor-section-code"],
    mutationFn: async () => {
      const res = await axiosInstance.post<ResendResponse>(
        "/successor/resend-section-code"
      );
      return res.data;
    },
    onMutate: () => {
      Toast({
        id: "resendSuccessorSectionCode",
        message: "Wysyłanie kodu...",
        type: TOAST_TYPES_ENUM.LOADING,
      });
    },
    onSuccess: (data) => {
      Toast({
        id: "resendSuccessorSectionCode",
        message: "Kod został wysłany.",
        type: TOAST_TYPES_ENUM.SUCCESS,
      });
      options?.onSuccess?.(data);
    },
    onError: (err: any) => {
      Toast({
        id: "resendSuccessorSectionCode",
        message: err?.response?.data?.message || "Błąd wysyłki kodu",
        type: TOAST_TYPES_ENUM.ERROR,
      });
      options?.onError?.(err);
    },
    retry: false,
  });
}
